// Pre-defined cases with their manufacturing step locations
export const availableCases = {
  'Case 1': {
    title: 'Case 1: Module Only - Shanghai',
    manufacturingSteps: [
      { step: 'Module', location: 'China', city: 'Shanghai' }
    ],
    cities: ['Shanghai'],
    results: {
      // All components purchased from market (no manufacturing)
      polysiliconMarket: { baseline: 3.63, percentile10: 3.27, percentile50: 3.63, percentile90: 3.99 },
      ingotWaferMarket: { baseline: 5.54, percentile10: 4.43, percentile50: 5.54, percentile90: 6.65 },
      cellMarket: { baseline: 10.82, percentile10: 9.74, percentile50: 10.82, percentile90: 11.90 },
      moduleMarket: { baseline: 22.55, percentile10: 20.55, percentile50: 22.55, percentile90: 24.52 }
    }
  },
  'Case 2': {
    title: 'Case 2: China → Vietnam → Vietnam',
    manufacturingSteps: [
      { step: 'Ingot/Wafer', location: 'China', city: 'Shanghai' },
      { step: 'Cell', location: 'Vietnam', city: 'BacNinh' },
      { step: 'Module', location: 'Vietnam', city: 'BacNinh' }
    ],
    cities: ['Shanghai', 'BacNinh'],
    results: {
      // Market-purchased components
      polysiliconMarket: { baseline: 3.63, percentile10: 3.27, percentile50: 3.63, percentile90: 3.99 },
      ingotWaferMarket: { baseline: 5.54, percentile10: 4.43, percentile50: 5.54, percentile90: 6.65 },
      // Manufactured stages
      cellMSP: { baseline: 17.14, percentile10: 15.91, percentile50: 17.11, percentile90: 18.34 },
      moduleMSP: { baseline: 34.8, percentile10: 33.28, percentile50: 34.78, percentile90: 36.32 }
    }
  },
  'Case 3': {
    title: 'Case 3: China → Vietnam → Belgium',
    manufacturingSteps: [
      { step: 'Ingot/Wafer', location: 'China', city: 'Shanghai' },
      { step: 'Cell', location: 'Vietnam', city: 'BacNinh' },
      { step: 'Module', location: 'Belgium', city: 'Brussels' }
    ],
    cities: ['Shanghai', 'BacNinh', 'Brussels'],
    results: {
      // Market-purchased components
      polysiliconMarket: { baseline: 3.63, percentile10: 3.27, percentile50: 3.63, percentile90: 3.99 },
      ingotWaferMarket: { baseline: 5.54, percentile10: 4.43, percentile50: 5.54, percentile90: 6.65 },
      // Manufactured stages
      cellMSP: { baseline: 17.14, percentile10: 15.91, percentile50: 17.11, percentile90: 18.34 },
      moduleMSP: { baseline: 40.87, percentile10: 39.18, percentile50: 40.85, percentile90: 42.56 }
    }
  },
  'Case 4': {
    title: 'Case 4: China → Vietnam → Vietnam → Belgium',
    manufacturingSteps: [
      { step: 'Polysilicon', location: 'China', city: 'Shanghai' },
      { step: 'Ingot/Wafer', location: 'Vietnam', city: 'BacNinh' },
      { step: 'Cell', location: 'Vietnam', city: 'BacNinh' },
      { step: 'Module', location: 'Belgium', city: 'Brussels' }
    ],
    cities: ['Shanghai', 'BacNinh', 'Brussels'],
    results: {
      // Market-purchased component
      polysiliconMarket: { baseline: 3.63, percentile10: 3.27, percentile50: 3.63, percentile90: 3.99 },
      // Manufactured stages
      ingotWaferMSP: { baseline: 23.81, percentile10: 22.63, percentile50: 23.8, percentile90: 25.04 },
      cellMSP: { baseline: 36.1, percentile10: 34.59, percentile50: 36.11, percentile90: 37.57 },
      moduleMSP: { baseline: 59.33, percentile10: 57.37, percentile50: 59.33, percentile90: 61.23 }
    }
  },
  'Case 5': {
    title: 'Case 5: Spain Full Integration',
    manufacturingSteps: [
      { step: 'Polysilicon', location: 'Spain', city: 'Bilbao' },
      { step: 'Ingot/Wafer', location: 'Spain', city: 'Bilbao' },
      { step: 'Cell', location: 'Spain', city: 'Bilbao' },
      { step: 'Module', location: 'Spain', city: 'Bilbao' }
    ],
    cities: ['Bilbao'],
    results: {
      // All values in $/m² from combinationsData (polysilicon converted from $/kg using 0.595 kg/m²)
      polysiliconMSP: { baseline: 12.32, percentile10: 10.36, percentile50: 12.36, percentile90: 14.01 },
      ingotWaferMSP: { baseline: 35.31, percentile10: 32.29, percentile50: 35.36, percentile90: 38.68 },
      cellMSP: { baseline: 50.76, percentile10: 46.42, percentile50: 50.78, percentile90: 54.46 },
      moduleMSP: { baseline: 70.72, percentile10: 66.15, percentile50: 70.65, percentile90: 75.67 }
    }
  },
  'Case 6': {
    title: 'Case 6: Sweden → France → France → Italy',
    manufacturingSteps: [
      { step: 'Polysilicon', location: 'Sweden', city: 'Stockholm' },
      { step: 'Ingot/Wafer', location: 'France', city: 'Marseille' },
      { step: 'Cell', location: 'France', city: 'Moselle' },
      { step: 'Module', location: 'Italy', city: 'Padua' }
    ],
    cities: ['Stockholm', 'Marseille', 'Moselle', 'Padua'],
    results: {
      // All values in $/m² from combinationsData (polysilicon converted from $/kg using 0.595 kg/m²)
      polysiliconMSP: { baseline: 11.46, percentile10: 9.45, percentile50: 11.37, percentile90: 13.25 },
      ingotWaferMSP: { baseline: 36.33, percentile10: 33.63, percentile50: 36.41, percentile90: 40.13 },
      cellMSP: { baseline: 53.76, percentile10: 50.13, percentile50: 53.67, percentile90: 57.61 },
      moduleMSP: { baseline: 74.43, percentile10: 70.95, percentile50: 74.15, percentile90: 79.56 }
    }
  },
  'Case 7': {
    title: 'Case 7: Sweden → Sweden → Italy → France',
    manufacturingSteps: [
      { step: 'Polysilicon', location: 'Sweden', city: 'Sundsval' },
      { step: 'Ingot/Wafer', location: 'Sweden', city: 'Sundsval' },
      { step: 'Cell', location: 'Italy', city: 'Padua' },
      { step: 'Module', location: 'France', city: 'Marseille' }
    ],
    cities: ['Sundsval', 'Padua', 'Marseille'],
    results: {
      // All values in $/m² from combinationsData (polysilicon converted from $/kg using 0.595 kg/m²)
      polysiliconMSP: { baseline: 11.23, percentile10: 8.89, percentile50: 11.30, percentile90: 13.83 },
      ingotWaferMSP: { baseline: 34.94, percentile10: 30.68, percentile50: 34.94, percentile90: 38.57 },
      cellMSP: { baseline: 51.82, percentile10: 47.07, percentile50: 51.90, percentile90: 55.98 },
      moduleMSP: { baseline: 73.38, percentile10: 68.94, percentile50: 73.72, percentile90: 79.13 }
    }
  }
};

// Cities used in simulations with coordinates for the map
// Using approximate regional coordinates (not precise city locations) to protect location privacy
export const europeanCities = {
  'Berlin': { lat: 52.5, lng: 13.0, country: 'Germany' },
  'Marseille': { lat: 43.5, lng: 5.0, country: 'France' },
  'Moselle': { lat: 49.0, lng: 6.5, country: 'France' },
  'Padua': { lat: 45.5, lng: 11.5, country: 'Italy' },
  'Bilbao': { lat: 43.0, lng: -3.5, country: 'Spain' },
  'Stockholm': { lat: 59.5, lng: 17.5, country: 'Sweden' },
  'Sundsval': { lat: 63.0, lng: 17.0, country: 'Sweden' },
  'BacNinh': { lat: 21.5, lng: 106.0, country: 'Vietnam' },
  'Brussels': { lat: 50.5, lng: 4.5, country: 'Belgium' },
  'Shanghai': { lat: 31.0, lng: 121.0, country: 'China' }
};

// Manufacturing steps
export const manufacturingSteps = [
  'Polysilicon',
  'Ingot/Wafer',
  'Cell',
  'Module'
];

// Regions
export const regions = ['EU', 'China', 'South East Asia'];